export default __webpack_public_path__ + "static/media/gift4.e221b46a.png";